module.exports = __webpack_public_path__ + "static/media/EyeIcon.86569794.svg";